module.exports = __webpack_public_path__ + "static/media/12UNCTAD13.eed176e5.jpg";